module.exports = __webpack_public_path__ + "img/sale-tag.7a53854c.png";